import { BatchStatusEnum } from "../enums/batch-status.enum";
import { CompanyDTO } from "./CompanyInfoDTO";
import { CompanyPlaceDTO } from "./CompanyPlaceDTO";
import { ReachedPlaceDTO } from "./ReachedPlacesDTO";



interface RankingInfo {
  TotalBids: number;
  WinningBids: number;
  MyAmount: number;
  Place: CompanyPlaceDTO;
}

export class BatchDTO {
  public Quantity?: number;
  public TotalOffers?: number;
  public Timing?: number;
  public StartingPrice?: number;
  public StartDate?: Date;
  public EndDate?: Date;
  public Delivery?: Date;
  public Company: CompanyDTO;
  public Status?: BatchStatusEnum;
  public CompanyPlace?: any; //in uscita è un oid
  public Oid?: number;
  public Step?: number;
  public Weight?: number;
  public ReachedPlaces?: ReachedPlaceDTO[];
  public RankingInfos?: RankingInfo; // Nuova proprietà

  constructor(public Name?: string) {}

  public static create = (name?: string) => new BatchDTO(name);

  public setCompanyPlace(oid: number) {
    this.CompanyPlace = { Oid: oid };
    return this;
  }

  public setQuantity(quantity: number) {
    this.Quantity = quantity;
    return this;
  }

  public setTotalOffers(totalOffert: number) {
    this.TotalOffers = totalOffert;
    return this;
  }

  public setStartingPrice(startingPrice: number) {
    this.StartingPrice = startingPrice;
    return this;
  }

  public setDelivery(delivery: Date) {
    this.Delivery = delivery;
    return this;
  }

  public setTiming(timing: number) {
    this.Timing = timing;
    return this;
  }

  public setStartDate(startDate: Date) {
    this.StartDate = startDate;
    return this;
  }

  public setStatus(status: BatchStatusEnum) {
    this.Status = status;
    return this;
  }

  public setOid(oid: number) {
    this.Oid = oid;
    return this;
  }

  public setStep(step: number) {
    this.Step = step;
    return this;
  }

  public setWeight(weight: number) {
    this.Weight = weight;
    return this;
  }

  public setReachedPlaces(places: ReachedPlaceDTO[]) {
    this.ReachedPlaces = places;
    return this;
  }

  public setRankingInfos(rankingInfos: RankingInfo) {
    this.RankingInfos = rankingInfos;
    return this;
  }
}